import { render, staticRenderFns } from "./pages17.vue?vue&type=template&id=fa7da808&scoped=true&"
import script from "./pages17.vue?vue&type=script&lang=js&"
export * from "./pages17.vue?vue&type=script&lang=js&"
import style0 from "./pages17.vue?vue&type=style&index=0&id=fa7da808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7da808",
  null
  
)

export default component.exports